import { useProjects } from '@/hooks/queries/useProjects';
import ProjectCard from '@/components/domain/ProjectCard';
import LoadingState from '@/components/common/LoadingState';

export default function ProjectsList() {
  const { data: projects, isLoading } = useProjects();

  if (isLoading) {
    return <LoadingState />;
  }

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">All Projects</h1>
      {projects && projects.length > 0 ? (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      ) : (
        <p className="text-gray-600">No projects found. Create your first project to get started!</p>
      )}
    </div>
  );
}
